/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Agent_Run_Approval_WantsInputs */



/**
* | output |
* | --- |
* | "{agent} wants to do this:" |
*
* @param {Agent_Run_Approval_WantsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_wants = /** @type {((inputs: Agent_Run_Approval_WantsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_WantsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.agent} möchte Folgendes tun:`)
	return /** @type {LocalizedString} */ (`${i?.agent} wants to do this:`)
});